function Form() {
	this.init();
}

Form.prototype.init = function () {
	$('body').on('submit', 'form.ajax', function (e) {
		e.preventDefault();
		var self	 = $(this);
		var url 	 = $(this).attr('action');
		var formData = $( this ).serialize();
		self.find('input').attr('disabled','disabled');
		self.addClass('-sending');
		$.ajax({
			type        : 'POST',
			url         : url,
			data        : formData,
			dataType    : 'json',
		}).done(function(data) {
			self.find('div.error').removeClass("error");
			self.find('span.errorinfo').removeClass('-active');
			self.find('input.error').removeClass('error');
			if (data.fails) {
				for (var name in data.errors) {
					console.log(name);
					var error = self.find('p.error-info');
					$('input[name='+name+']').addClass('error');
					error.html(data.errors[name]).addClass('-active');
				}
				self.removeClass('-sending').find('input').removeAttr('disabled');
			}
			else {
				self.after('<p>Dziękujemy za zapisanie się na nasz newsletter!</p>');
				self.remove();
			}
		});
	});
	function removeSpecialCharacters(str_) {
		if (str_===undefined) return "";
		var str = "";
		str+=str_;
		var mapObj = {
			ó:"o",
			ł:"l",
			ń:"n",
			ę:"e",
			ą:"a",
			ś:"s",
			ć:"c",
			ź:"z",
			ż:"z"
		};
		str = str.replace(/ó|ł|ń|ę|ę|ą|ś|ć|ż|ź/gi, function(matched) {
			return mapObj[matched];
		});
		return str;
	}
	$('form.employee-search').submit(function(e){
		e.preventDefault();
		$('.cloned').remove();
		var input = $('form.employee-search input').val();
		var result = input.toLowerCase().split(" ");
		//console.log(result);
		var regularName = new RegExp(removeSpecialCharacters(result[0]));
		var regularSurname = new RegExp(removeSpecialCharacters(result[1]));
		if ($('.result-list').is(':empty')) {
			$('.no-results').removeClass('-hidden');
		}
		$('.hide-for-small-only > .accordion-content > div > a').each(function(){
			var employ = removeSpecialCharacters($(this).text().toLowerCase());
			if (input) {
				$('.result').removeClass('-hidden');
			} else {
				return;
			}
			if (regularName.test(employ) && regularSurname.test(employ)) {
				$('.no-results').addClass('-hidden');
				$(this).clone().prependTo('.result-list').addClass('cloned');
			}
		});
	});
	$('.result > .close').click(function(){
		$('.result').addClass('-hidden');
		$('.cloned').remove();
	});
};

$(document).ready(function() {
	var form;
	form = new Form();
});